module.exports = __webpack_public_path__ + "assets/img/欧瑞朗.32b8f252.png";